import AssignmentIcon from "@mui/icons-material/Assignment";
import StarRateIcon from "@mui/icons-material/StarRate";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import PersonIcon from "@mui/icons-material/Person";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AutoRenewIcon from "@mui/icons-material/Autorenew";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import BentoIcon from "@mui/icons-material/Bento";
import KeyboardArrowRightIcon from "../assets/icons/redArrowLeftIcon.svg";
import ArrowOutwardIcon from "../assets/icons/ArrowOutwardIcon.svg";
import DownloadIcon from "../assets/icons/download.svg";
import ApartmentIcon from "@mui/icons-material/Apartment";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import BugReportOutlinedIcon from "@mui/icons-material/BugReportOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import Face6OutlinedIcon from "@mui/icons-material/Face6Outlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import ConstructionIcon from "@mui/icons-material/Construction";
import SettingsIcon from "@mui/icons-material/Settings";
import FaceIcon from "@mui/icons-material/Face";
import paymentIcon from "../assets/icons/payment.svg";
import personIcon from "../assets/icons/person.svg";
import folderIcon from "../assets/icons/folder.svg";
import folderIconNew from "../assets/icons/folderIconNew.svg";
import downloadStatementIcon from "../assets/icons/download-statement.svg";
import worstIcon from "../assets/icons/Worst.svg";
import badIcon from "../assets/icons/Bad.svg";
import fineIcon from "../assets/icons/Fine.svg";
import goodIcon from "../assets/icons/Good.svg";
import bestIcon from "../assets/icons/Best.svg";
import worstClickIcon from "../assets/icons/Worst-enable.svg";
import badClickIcon from "../assets/icons/Bad-enable.svg";
import fineClickIcon from "../assets/icons/Fine-enable.svg";
import goodClickIcon from "../assets/icons/Good-enable.svg";
import bestClickIcon from "../assets/icons/Best-enable.svg";
import trackRequestIcon from "../assets/icons/track-request.svg";
import payPremiumIcon from "../assets/icons/pay-premium.svg";
import reinstatePolicyIcon from "../assets/icons/reinstate-policy.svg";
import changePaymentFeqIcon from "../assets/icons/change-payment-feq.svg";
import setupAutoPayIcon from "../assets/icons/setup-auto-pay.svg";
import repayLoanIcon from "../assets/icons/repay-loan.svg";
import emailIcon from "../assets/icons/email red.svg";
import mobileIcon from "../assets/icons/mobile.svg";
import locationIcon from "../assets/icons/location.svg";
import updatePanIcon from "../assets/icons/update-pan.svg";
import whatsappIcon from "../assets/icons/whatsapp.svg";
import eInsuranceIcon from "../assets/icons/e-insurance.svg";
import applyForLoanIcon from "../assets/icons/apply-for-loan.svg";
import bankAccountIcon from "../assets/icons/bank-account.svg";
import setAlertsIcon from "../assets/icons/set-alerts.svg";
import fileClaimIcon from "../assets/icons/file-claim.svg";
import survivalCertificateIcon from "../assets/icons/survival-certificate.svg";
import taxCertificateIcon from "../assets/icons/tax-certificate.svg";
import policyAccStatementIcon from "../assets/icons/policy-acc-statement.svg";
import policyBondIcon from "../assets/icons/policy-bond.svg";
import serviceReqIcon from "../assets/icons/service-req.svg";
import applicationTrackerIcon from "../assets/icons/application-tracker.svg";
import HandHeartIcon from "../assets/icons/hand-heart-icon.svg";
import CardAccountDetailsIcon from "../assets/icons/card-account-details-icon.svg";
import HandHeartOutlineIcon from "../assets/icons/hand-heart-outline-icon.svg";
import ElectricityBillIcon from "../assets/icons/electricity-bill-icon.svg";
import IdCardIcon from "../assets/icons/e-card-icon.svg";
import VectorIcon from "../assets/icons/Vector-icon.svg";
import CertificateIcon from "../assets/icons/certificate-icon.svg";
import CalendarIcon from "../assets/icons/calendar-today-icon.svg";
import HospitalBoxIcon from "../assets/icons/hospital-box-icon.svg";
import PencilIcon from "../assets/icons/pencil.svg";
import abcdLogoRed from "../assets/images/abcd-logo-tm-red.svg";
import adityaBirlaInsuranceLogo from "../assets/images/abcd-insurance-logo.svg";
import TransactIcon from "../assets/icons/transact-icon.svg";
import StatementIcon from "../assets/icons/statement-icon.svg";
import LinkFolioIcon from "../assets/icons/linkFolio-icon.svg";
import WebIcon from "../assets/icons/web-icon.svg";
import LaunchIcon from "@mui/icons-material/Launch";
import AccountStatementIcon from "../assets/icons/accountStatementIcon.svg";
import CapitalGainIcon from "../assets/icons/capital-gain-icon.svg";
import RedeemIcon from "../assets/icons/redeem-icon.svg";
import SwitchIcon from "../assets/icons/switch-icon.svg";
import SwpIcon from "../assets/icons/swp-icon.svg";
import StpIcon from "../assets/icons/stp-icon.svg";
import ViewBankIcon from "../assets/icons/viewbank-icon.svg";
import RegisterOTMIcon from "../assets/icons/register-otm-icon.svg";
import myClaimsIcon from "../assets/icons/myclaims-icon.svg";
import myRequestIcon from "../assets/icons/myrequests-icon.svg";
import utilitiesIcon from "../assets/icons/utilities-icon.svg";
import calladoctorIcon from "../assets/icons/calldoctor-icon.svg";
import serviceRequestIcon from "../assets/icons/shape-plus.svg";
import handCoinIcon from "../assets/icons/hand-coin.svg";
import textBoxIcon from "../assets/icons/text-box.svg";
import welcomeKitIcon from "../assets/icons/welcome-kit.svg";
import playListIcon from "../assets/icons/playlist-check.svg";
import textBoxCheckIcon from "../assets/icons/text-box-check.svg";
import homeIcon from "../assets/icons/home.svg";
import downloadHL from "../assets/icons/download-icon.svg";
import renewalsIcon from "../assets/icons/renewals-icon.svg";
import setupENACHIcon from "../assets/icons/setupENACH.svg";
import setupESIIcon from "../assets/icons/setupESI.svg";
import pauseCancelIcon from "../assets/icons/pause-cancel-icon.svg";
import addModifyNomineeIcon from "../assets/icons/add-modify-nominee-icon.svg";
import changeContactIcon from "../assets/icons/change-contact-icon.svg";
import createABHAIdIcon from "../assets/icons/create-abhaId-icon.svg";
import bmiCalculatorIcon from "../assets/icons/bmi-calculator-icon.svg";
import activeAgeCalculatorIcon from "../assets/icons/activeAge-calculator-icon.svg";
import CashlessNetworkIcon from "../assets/icons/hospital-building.svg";

import changeAddressIcon from "../assets/icons/home-icon.svg";
import changeMobileIcon from "../assets/icons/change-mobil-icon.svg";
import changeEmiIcon from "../assets/icons/change-emi-date-icon.svg";
import changeEmiTenureIcon from "../assets/icons/calendar-end-icon.svg";
import excessEmiRefundIcon from "../assets/icons/calculator-red-icon.svg";
import tdsRefundIcon from "../assets/icons/cash-refund-icon.svg";
import changeEnachIcon from "../assets/icons/enach-icon.svg";
import { T_CmsRateContentVariables } from "../features/Features_Cms/CmsRateContentVariables.Types";
import AddIcon from "@mui/icons-material/Add";
import whatsappOptInIcon from "../assets/icons/whatsapp-opt-in-icon.svg";
import viewDashboard from "../assets/icons/view-dashboard.svg";
import redirectionIcon from "../assets/icons/chevron-left.svg";

import {
  APi_DownloadPolicyAccountStatement,
  Api_DownloadTaxCertificate,
  Api_FetchDashboardDetails,
  Api_FetchPolicyDetails,
  Api_FetchPolicyDetailsByMobileNumber,
  Api_FetchProfile_Details,
  Api_GetCustomerLobDetails,
  Api_SendEmail,
  Api_SendWhatsApp,
} from "./ApiEndpoints";
import { T_CreateCaseRequest } from "../features/Feature_LifeInsurance/LifeInsurance_Types";
import { T_CreateCaseAPIRequest } from "../features/Feature_Homeloan/Homeloan_Types";
import { T_menu } from "../features/Feature_GeneralAppElements/GeneralAppElements_Types";
import { T_OnUserLoginCleverTapStatic } from "../globalTypes/GlobalTypes";

export const ABCD_SUPERAPP_SOURCE_NAME = "ABCD SUPER APP";
export const ABCD_SUPERAPP_URL = process.env.REACT_APP_ABCD_SUPERAPP_URL;
export const tabViewPoint = 768;
export const REACT_APP_URL = process.env.REACT_APP_URL;
export const iOSType = "iOS";
export const androidType = "Android";

export const ABCD_PLAYSTORE_URL = process.env.REACT_APP_ABCD_PLAYSTORE_URL;
export const ABCD_APPSTORE_URL = process.env.REACT_APP_ABCD_APPSTORE_URL;

export const ABC_SERVICE_PLAYSTORE_URL =
  process.env.REACT_APP_ABC_SERVICE_PLAYSTORE_URL;
export const ABC_SERVICE_APPSTORE_URL =
  process.env.REACT_APP_ABC_SERVICE_APPSTORE_URL;

export const ABCD_APPSTORE_SCHEME = "abcd://adityabirlacapitaldigital.com";
export const ABCD_SUPER_APP_APPSTORE_URL =
  "https://apps.apple.com/in/app/abcd-aditya-birla-capital/id6477909524";
export const ABCD_SUPER_APP_PLAYSTORE_URL =
  "https://play.google.com/store/apps/details?id=com.adityabirlacapitaldigital.OneApp";
export const ABCD_SUPER_APP_SCHEME =
  "abcd://adityabirlacapitaldigital.com?mobileNumber=";

export const MF_API_BASE_URL = process.env.REACT_APP_MF_API_BASE_URL;
export const TRADE_US_URL =
  "https://apps.apple.com/in/app/abcd-aditya-birla-capital/id6477909524?mt=8";
export const ONE_LOGIN_DASHBOARD =
  "https://onelogin.adityabirlacapital.com/my-dashboard";
export const USE_DEV_TEST_DATA: boolean = false;
export const ABCD_SUPER_APP_PACKAGE_NAME = "com.adityabirlacapital.abconeapp";
export const ABCD_SUPER_APP_BUNDLE_ID = "123456789"; //need to replace with original value

export const MF_LOB_ID = "ABSLAMC";
export const STOCK_LOB_ID = "ABML";
export const LOANS_LOB_ID = "ABFL";

export const UI_SESSION_TIMEOUT = 5 * 60 * 1000;
export const UI_SESSION_TIMEOUT_PROMT = 0.5 * 60 * 1000;
export const ABCDLobCode = "25";
export const LiLobCode = "ABSLI";
export const HiLobCode = "ABHI";
export const HlLobCode = "ABHFL";
export const MfLobCode = "ABSLAMC";
export const StockLobCode = "ABML";
export const PersonalLoansLobCode = "ABFL";
export const ABCDHoldingsLobCode = "ABCD";
export const OneLoginLobCode = "11";
export const OneLoginRedirectUrl = "https://uatonelogin.abcscuat.com/Interface";
export const HiDestinationLobId = "06";
export const LiDestinationLobId = "02";
export const MfDestinationLobId = "01";
export const SsDestinationLobId = "24";
export const LoansDestinationLobId = "03";
export const HomeLoansDestinationLobId = "04";
export const Abcd_Super_App_Lob_Id = "25";
export const Cs_App_Lob_Id = "26";
export const onlyAlphaNumericRegex = /^[A-Za-z0-9]+$/;
export const ALPHA_NUMERIC_WITH_SPACE_REGEX = /[^a-zA-Z0-9 ]/g;
export const folioApiReqBodyUserId = "MF_Tan";
export const folioApiReqBodyPSW = "VUFUX1Rhbg==";

export const REGISTER_BIO_METRIC = "REGISTER_BIO_METRIC";
export const OneLoginProdUrl = "https://onelogin.adityabirlacapital.com/login";

export const ABC_APP_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.adityabirlacapital.abconeapp";
export const ABC_APP_APP_STORE_URL =
  "https://apps.apple.com/us/app/aditya-birla-capital/id1573921028";
export const ABC_ONE_LOGIN_URL =
  "https://onelogin.adityabirlacapital.com/login";

export enum InAppFeatureFuncCodes {
  LI_DOWNLOAD_STATMENTS_DRAWER = "02MS",
  LI_DETAILS_PAGE = "01DP",
  LI_UPDATE_PAN = "02UP",
  LI_UPDATE_EMAIL = "02UPEM",
  LI_UPDATE_MOBILE_NUMBER = "02UPMONU",
  LI_WHATSAPP_OPT_IN_OUT = "02WHTS_IN_OUT",
  LI_ADD_UPDATE_BANK_ACCOUNT = "02AUBD",
  LI_UPDATE_NOMINEE = "02UPNO",
  LI_POLICY_ACCOUNT_STATEMENT = "PAC",
  LI_PREMIUM_RECEIPTS = "PR",
  LI_APP_TAX_CERTIFICATE = "TC",
  LI_ADD_UPDATE_NOMINEE = "02AUND",
  HL_AMORTIZATION_SCHEDULE = "04AS",
  IN_APP_E_NACH = "04CEN",
  HL_PROVISIONAL_INTEREST_CERTIFICATE = "04PIC",
  HL_STATEMENTS_DOCUMENTS_WELCOME_KIT = "04WKIT",
  HL_STATEMENTS_DOCUMENTS_REPAYMENT_SCHEDULE = "04SDRS",
  HL_STATEMENT_OF_ACCOUNT = "04DSA",
  HL_ACCOUNT_RELATED_SWAP_MANDATE = "04ASM",
  HL_DISBURSEMENT_REQUEST = "04DR",
  HL_INTEREST_CERTIFICATE = "04DIC",
  HL_STATEMENTS_DOCUMENTS_WELCOME_KIT_ALT = "04SDK2",
  HL_MOBILE_NUMBER_CHANGE = "04MNC",
  HL_PROFILE_RELATED = "04PR",
  HL_STATEMENTS_DOCUMENTS_BALANCE_CONFIRMATION_LETTER = "04SDBCL",
  HL_ACCOUNT_RELATED_EMI_EXCESS_RELATED = "04AER",
  HL_TDS_REFUND = "04TR",
  HL_ACCOUNT_RELATED_GST_INVOICE = "04AGI",
  HL_STATEMENTS_DOCUMENTS_INSURANCE_COPY = "04SDIC",
  HL_ACCOUNT_RELATED_EMI_DATE_CHANGE = "04AEDC",
  HL_CHANGE_EMI_TENURE = "04CET",
  HL_GST_INVOICE = "04GI",
  HL_UPDATE_EMAIL = "04UE",
  HL_IN_APP_EMI_PAYMENT = "04OEMI",
  HL_CHANGE_ADDRESS = "04CA",
  HL_LIST_OF_DOCUMENTS = "04LOD",
  HI_EDIT_MOBILE_NUMBER = "06CDEM",
  HI_ALTERNATE_MOBILE_NUMBER = "06CDAM",
  HI_EMAIL = "06CDM",
  HI_ADDRESS = "06CDA",
  HI_UPDATE_NOMINEE = "06ND",
  HI_EDIT_PAN = "06PDEP",
  HI_PROPOSER_NAME = "06PDPN",
  HI_DOB = "06PDDOB",
  HI_GENDER = "06PDG",
  HI_DETAIL_PAGE = "06HID",
  HI_POLICY_DOCUMENTS = "06PODC",
  HI_PREMIUMCERTIFICATE = "06PDPC",
  HI_POLICYSCHEDULE = "06PDPS",
  HI_POLICYWORDINGS = "06PDPW",
  HI_ECARD = "06PDEC",
  HI_ABHA_ID = "06QAABHAID",
  HI_CALL_DOCTOR = "06QACD",
  HI_MY_REQUEST = "06QAMR",
  HI_QUICK_ACTION_MAIN_MENU = "06QA",
  HI_POLICY_RENEWAL = "06POREN",
  HI_TRACKING_CLAIM = "06TRCKCLM",
  HI_MY_CLAIM = "06MYCLM",
  HI_RAISE_CLAIM = "06RAISECLM",
  HI_UTILITIES = "06UTI",
  HI_CASHLESS_NETWORK_HOSPITAL = "06UTICNH",
  HI_BMI_CALCULATOR = "06UTIBMI",
  HI_ACTIVE_AGE_CALCULATOR = "06UTIAAC",
  HI_CONTACT_DETAILS = "06CD",
  HI_PROPOSER_DETAILS = "06PD",
  GA_INSURANCE_TAB_HOME = "DINS",
  GA_INVESTMENT_TAB_HOME = "DINV",
  GA_LOAN_TAB_HOME = "DLO",
  GA_SEARCH = "GAS",
  GA_DASHBOARD = "D",
}

export enum DEVICE_TYPE {
  MOBILE = "150",
  WEB = "151",
  PWA_WEB = "152",
  PWA_MOBILE = "153",
  ABC_WEB_MOB_CS = "155",
}

export enum SCREEN_TYPE {
  StockScreenType = "ss_servicing",
  HFScreenType = "hfl_servicing",
  HIScreenType = "hi_servicing",
  LIScreenType = "li_servicing",
  MFScreenType = "mf_servicing",
  DashboardScreenType = "servicing_homescreen_dashboard",
  generalAppType = "ga_servicing",
  PreLoginScreenType = "servicing_pre_login",
  LoginScreenType = "servicing_login",
}

export enum UI_IDLE_STATUS {
  ACTIVE = "ACTIVE",
  IDLE = "IDLE",
  PROMPTED = "PROMPTED",
}

export const accordionList = [
  { title: "Plan Details", icon: AssignmentIcon },
  { title: "Rider Details", icon: StarRateIcon },
  { title: "Premium Details", icon: WorkspacePremiumIcon },
  { title: "Personal Details", icon: PersonIcon },
  { title: "Nominee Details", icon: PeopleAltIcon },
  { title: "Renewal Payment Details", icon: AutoRenewIcon },
  { title: "Bank Account Details", icon: AccountBalanceIcon },
  { title: "Agent Details", icon: HeadsetMicIcon },
  { title: "Fund Details", icon: BentoIcon },
];

export const planDetails = [
  { label: "Policy Owner Name", value: "MS Akansha Sharma" },
  { label: "Client ID", value: "2098335109" },
  { label: "Purpose of Insurance", value: "Wealth Creation" },
  { label: "e-Insurance Number", value: "4100012177398" },
  { label: "Premium Payment Term", value: "5 Years" },
  { label: "Policy Term", value: "10 Years" },
];

export const LI_ServiceList = [
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 1,
    menuName: "Payment",
    menuDisplayName: "Payment",
    menuIcon: paymentIcon,
    parentMenuId: 1,
    menuDetails: [],
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 2,
    menuName: "Update Profile",
    menuDisplayName: "Update Profile",
    menuIcon: personIcon,
    parentMenuId: 1,
    menuDetails: [],
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 3,
    menuName: "Policy Services",
    menuDisplayName: "Policy Services",
    menuIcon: folderIcon,
    parentMenuId: 1,
    menuDetails: [],
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 4,
    menuName: "Download Statements",
    menuDisplayName: "Download Statements",
    menuIcon: downloadStatementIcon,
    parentMenuId: 1,
    menuDetails: [],
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 5,
    menuName: "Track Request",
    menuDisplayName: "Track Request",
    menuIcon: trackRequestIcon,
    parentMenuId: 1,
    menuDetails: [],
  },
];

export const quickActionList = [
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 1,
    menuName: "My documents",
    menuDisplayName: "My documents",
    menuIcon: folderIcon,
    parentMenuId: 1,
    menuDetails: [],
    pathname: "my-documents",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 1,
    menuName: "My profile details",
    menuDisplayName: "My profile details",
    menuIcon: personIcon,
    parentMenuId: 1,
    menuDetails: [],
    pathname: "my-profile",
  },
];

export const paymentListConst = [
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 1,
    menuName: "Pay premium",
    menuDisplayName: "Pay premium",
    menuIcon: payPremiumIcon,
    parentMenuId: 11,
    menuDetails: [],
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 2,
    menuName: "Reinstate Policy",
    menuDisplayName: "Reinstate Policy",
    menuIcon: reinstatePolicyIcon,
    parentMenuId: 11,
    menuDetails: [],
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 3,
    menuName: "Change payment frequency",
    menuDisplayName: "Change payment frequency",
    menuIcon: changePaymentFeqIcon,
    parentMenuId: 11,
    menuDetails: [],
  },
  // {
  //   title: "Setup Auto-Pay",
  //   preIcon: setupAutoPayIcon,
  //   postIcon: ArrowOutwardIcon,
  // },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 4,
    menuName: "Setup ENACH",
    menuDisplayName: "Setup ENACH",
    menuIcon: setupENACHIcon,
    parentMenuId: 11,
    menuDetails: [],
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 5,
    menuName: "Setup ESI",
    menuDisplayName: "Setup ESI",
    menuIcon: setupESIIcon,
    parentMenuId: 11,
    menuDetails: [],
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 6,
    menuName: "Repay Loan",
    menuDisplayName: "Repay Loan",
    menuIcon: repayLoanIcon,
    parentMenuId: 11,
    menuDetails: [],
  },
];

export const updateProfileListConst = [
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 1,
    menuName: "Update Email Id",
    menuDisplayName: "Update Email Id",
    menuIcon: emailIcon,
    parentMenuId: 12,
    menuDetails: [],
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 2,
    menuName: "Update Mobile Number",
    menuDisplayName: "Update Mobile Number",
    menuIcon: mobileIcon,
    parentMenuId: 12,
    menuDetails: [],
    errorMessage: "",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 3,
    menuName: "Update Address",
    menuDisplayName: "Update Address",
    menuIcon: locationIcon,
    parentMenuId: 12,
    menuDetails: [],
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 4,
    menuName: "Update PAN",
    menuDisplayName: "Update PAN",
    menuIcon: updatePanIcon,
    parentMenuId: 12,
    menuDetails: [],
    pathName: "update-PAN",
    errorMessage: "",
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 5,
    menuName: "WhatsApp Opt in/out",
    menuDisplayName: "WhatsApp Opt in/out",
    menuIcon: whatsappIcon,
    parentMenuId: 12,
    menuDetails: [],
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 6,
    menuName: "Open e-Insurance Account",
    menuDisplayName: "Open e-Insurance Account",
    menuIcon: eInsuranceIcon,
    parentMenuId: 12,
    menuDetails: [],
  },
];

export const policyServicesListConst = [
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 1,
    menuName: "Apply for Loan",
    menuDisplayName: "Apply for Loan",
    menuIcon: applyForLoanIcon,
    parentMenuId: 13,
    menuDetails: [],
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 2,
    menuName: "Add/Update Nominee",
    menuDisplayName: "Add/Update Nominee",
    menuIcon: payPremiumIcon,
    parentMenuId: 13,
    menuDetails: [],
    errorMessage: "",
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 3,
    menuName: "Add/Update Bank Account",
    menuDisplayName: "Add/Update Bank Account",
    menuIcon: bankAccountIcon,
    parentMenuId: 13,
    menuDetails: [],
    pathName: "addUpdate-bankAccount",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 4,
    menuName: "Set Alerts",
    menuDisplayName: "Set Alerts",
    menuIcon: setAlertsIcon,
    parentMenuId: 13,
    menuDetails: [],
    // pathname: "set-alerts",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 5,
    menuName: "Fund Switch/Premium Redirection",
    menuDisplayName: "Fund Switch/Premium Redirection",
    menuIcon: changePaymentFeqIcon,
    parentMenuId: 13,
    menuDetails: [],
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 6,
    menuName: "File Claim",
    menuDisplayName: "File Claim",
    menuIcon: fileClaimIcon,
    parentMenuId: 13,
    menuDetails: [],
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 7,
    menuName: "Survival Certificate",
    menuDisplayName: "Survival Certificate",
    menuIcon: survivalCertificateIcon,
    parentMenuId: 13,
    menuDetails: [],
  },
];

export const downloadStatementListConst = [
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 1,
    menuName: "Tax Certificate",
    menuDisplayName: "Tax Certificate",
    menuIcon: taxCertificateIcon,
    parentMenuId: 14,
    menuDetails: [],
    pathName: "tax-certificate",
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 2,
    menuName: "Premium Receipts",
    menuDisplayName: "Premium Receipts",
    menuIcon: applyForLoanIcon,
    parentMenuId: 14,
    menuDetails: [],
    pathName: "premium-receipts",
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 3,
    menuName: "Policy Account Statement",
    menuDisplayName: "Policy Account Statement",
    menuIcon: policyAccStatementIcon,
    parentMenuId: 14,
    menuDetails: [],
    pathName: "policy-account-statement",
  },
  {
    ctaIcon1: DownloadIcon,
    menuId: 4,
    menuName: "Policy Bond",
    menuDisplayName: "Policy Bond",
    menuIcon: policyBondIcon,
    parentMenuId: 14,
    menuDetails: [],
    pathName: "policy-bond",
  },
];

export const trackRequestListConst = [
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 1,
    menuName: "Service Request",
    menuDisplayName: "Service Request",
    menuIcon: serviceReqIcon,
    parentMenuId: 15,
    menuDetails: [],
  },
  // {
  //   title: "Application Tracker",
  //   preIcon: applicationTrackerIcon,
  //   postIcon: ArrowOutwardIcon,
  // },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 2,
    menuName: "Claims Tracker",
    menuDisplayName: "Claims Tracker",
    menuIcon: policyAccStatementIcon,
    parentMenuId: 15,
    menuDetails: [],
  },
];

export const QuickOptionListMf = [
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 1,
    menuName: "Transact",
    menuDisplayName: "Transact",
    menuIcon: TransactIcon,
    parentMenuId: 3,
    menuDetails: [],
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 2,
    menuName: "My Statements",
    menuDisplayName: "My Statements",
    menuIcon: folderIcon,
    parentMenuId: 3,
    menuDetails: [],
  },
  // {
  //   title: "Link/Delink folios",
  //   preIcon: LinkFolioIcon,
  //   postIcon: KeyboardArrowRightIcon,
  // },
  // {
  //   title: "Go to ABSLMF Portal",
  //   preIcon: WebIcon,
  //   postIcon: LaunchIcon,
  // },
];

export const mfStatementList = [
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 1,
    menuName: "Account statement",
    menuDisplayName: "Account statement",
    menuIcon: AccountStatementIcon,
    parentMenuId: 4,
    menuDetails: [],
    pathname: "account-statement",
    parent: "My Statements",
    parentKey: "my_statements",
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 2,
    menuName: "Capital gain statement",
    menuDisplayName: "Capital gain statement",
    menuIcon: CapitalGainIcon,
    parentMenuId: 4,
    menuDetails: [],
    pathname: "capital-gains",
    parent: "My Statements",
    parentKey: "my_statements",
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 3,
    menuName: "Exit load",
    menuDisplayName: "Exit load",
    menuIcon: CapitalGainIcon,
    parentMenuId: 4,
    menuDetails: [],
    pathname: "exit-load",
    parent: "My Statements",
    parentKey: "my_statements",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 4,
    menuName: "Transaction statement",
    menuDisplayName: "Transaction statement",
    menuIcon: TransactIcon,
    parentMenuId: 4,
    menuDetails: [],
    pathname: "transaction-statement",
    parent: "My Statements",
    parentKey: "my_statements",
  },
];

export const mfTransactList = [
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 1,
    menuName: "Redeem",
    menuDisplayName: "Redeem",
    menuIcon: RedeemIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "redeem",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 2,
    menuName: "SWP",
    menuDisplayName: "SWP",
    menuIcon: SwpIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "swp",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 3,
    menuName: "Switch",
    menuDisplayName: "Switch",
    menuIcon: SwitchIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "switch",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 4,
    menuName: "STP",
    menuDisplayName: "STP",
    menuIcon: StpIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "stp",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 5,
    menuName: "Pause/Cancel SIP",
    menuDisplayName: "Pause/Cancel SIP",
    menuIcon: pauseCancelIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "pause-cancel",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 6,
    menuName: "View/Add Bank",
    menuDisplayName: "View/Add Bank",
    menuIcon: ViewBankIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "view-add-bank",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 7,
    menuName: "Register OTM",
    menuDisplayName: "Register OTM",
    menuIcon: RegisterOTMIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "register-otm",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 8,
    menuName: "Add/Modify Nominee",
    menuDisplayName: "Add/Modify Nominee",
    menuIcon: addModifyNomineeIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "add-modify-nominee",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 9,
    menuName: "Change Contact",
    menuDisplayName: "Change Contact",
    menuIcon: changeContactIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "change-contact",
    parent: "Transact",
    parentKey: "transact",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 10,
    menuName: "WhatsApp Opt in",
    menuDisplayName: "WhatsApp Opt in",
    menuIcon: whatsappOptInIcon,
    parentMenuId: 5,
    menuDetails: [],
    pathname: "whatsapp-opt-in",
    parent: "Transact",
    parentKey: "transact",
  },
];

export const hamburgerMenuList = [
  {
    title: "My Profile",
    des: "Manage and edit your profile",
    preIcon: FaceIcon,
    pathname: "my-profile",
  },
  {
    title: "Utilities",
    des: "Discover hospitals, locate branches & more",
    preIcon: ConstructionIcon,
    pathname: "utilities",
  },
  {
    title: "Help & Support",
    des: "Contact us & FAQs",
    preIcon: HelpOutlineIcon,
    pathname: "help-&-support",
  },
  // {
  //   title: "App Settings",
  //   des: "App Setup: mPIN, permissions, biometrics",
  //   preIcon: SettingsIcon,
  //   pathname: "app-settings",
  // },
  {
    title: "Logout",
    des: "",
    preIcon: ExitToAppIcon,
    pathname: "logout",
  },
];

export const utilitiesMenuList = [
  {
    title: "Network hospital",
    preIcon: ApartmentIcon,
    url: "https://adityabirlanh.findmystore.io/locator/stores",
  },
  {
    title: "Branch locator",
    preIcon: LocationOnIcon,
    url: "https://adityabirla.findmystore.io/locator/stores",
  },
];

export const helpAndSupportMenuList = [
  {
    title: "Call us",
    preIcon: CallOutlinedIcon,
    pathname: "call-us",
  },
  {
    title: "Chat with us",
    preIcon: ChatBubbleOutlineIcon,
    pathname: "chat-with-us",
  },
  {
    title: "Email",
    preIcon: EmailOutlinedIcon,
    pathname: "email",
  },
  // {
  //   title: "FAQs",
  //   preIcon: QuizOutlinedIcon,
  //   pathname: "FAQs",
  // },
  {
    title: "Report a bug",
    preIcon: BugReportOutlinedIcon,
    pathname: "report-bug",
  },
];

export const appSettingsMenuList = [
  {
    title: "Change mPIN",
    preIcon: LockOutlinedIcon,
    pathName: "change-mPIN",
  },
  // {
  //   title: "Permission settings",
  //   preIcon: SettingsOutlinedIcon,
  //   pathName: "",
  // },
  // {
  //   title: "Device authentication settings",
  //   preIcon: Face6OutlinedIcon,
  //   pathName: "device-authentication-settings",
  // },
];

export const loansMenuList = [
  { title: "Personal Loan/Business Loan/Credit Cards" },
  // { title: "Business Loan" },
  // { title: "Credit Cards" },
];

export const FAQsMenuList = [
  { title: "General App FAQ", open: false },
  { title: "Loans", subList: loansMenuList, open: false },
  { title: "Invest", open: false },
  { title: "Insurance", open: false },
];

export const businessLoanMenuList = [
  { title: "Auto debit" },
  { title: "General" },
  { title: "Repayment" },
  { title: "KYC" },
];

export const homeLoanMenuList = [
  { title: "Repayment" },
  { title: "Auto Debit" },
  { title: "Miscellaneous" },
  { title: "General" },
  { title: "Bank statement" },
  { title: "Account Aggregator" },
];

export const autoDebitMenuList = [
  {
    title: "Can I cancel my life insurance policy? Are there any penalties?",
    des: [
      "Yes, you can cancel your life insurance policy if you wish to do so. However, it's important to understand that canceling a policy may have certain implications.",
      "Depending on the terms and conditions of your policy, there may be penalties or charges associated with canceling your policy. These penalties could vary based on the duration of the policy and any applicable surrender charges.",
    ],
  },
  {
    title: "What happens if I stop paying premiums or my policy lapses?",
  },
  {
    title: "How do I surrender or terminate my life insurance policy?",
  },
  {
    title:
      "What are the options for policy beneficiaries if the insured person passes away?",
  },
  {
    title:
      "Can I change the beneficiaries on my life insurance policy, and if so, how do I go about it?",
  },
];

export const FooterDetailsList = {
  privacyPolicy: {
    title: "PRIVACY POLICY",
    description: `Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home or any other place without the need of going to a designated place like an ATM.
  Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes.
  Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home.
  Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home or any other place without the need of going to a designated place like an ATM.
  Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes.
  Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home.`,
  },
  aboutUs: {
    title: "ABOUT US",
    description: `Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home or any other place without the need of going to a designated place like an ATM.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home or any other place without the need of going to a designated place like an ATM.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home.`,
  },
  termsAndConditions: {
    title: "TERMS & CONDITIONS",
    description: `Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home or any other place without the need of going to a designated place like an ATM.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home or any other place without the need of going to a designated place like an ATM.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes.
    Although you can make direct transfers to banks using ATM cards, it is less convenient than UPI transfers. You need to visit an ATM for money transfers and sometimes, the nearby ATMs may not be able to read the card’s bar code or have low servers. If payments through UPI VPA fail, you can try later at the comfort of your home.`,
  },
};

export const radioListData = [
  { label: "Download Now", key: "download", preIcon: downloadStatementIcon },
  { label: "Get it on Email Id", key: "email", preIcon: emailIcon },
  { label: "Get it on Whatsapp", key: "whatsapp", preIcon: whatsappIcon },
];

export const radioFamilyMembersData = [
  { radioLabel: "Mother", radioKey: "mother" },
  { radioLabel: "Father", radioKey: "father" },
  { radioLabel: "Spouse", radioKey: "spouse" },
  { radioLabel: "Daughter", radioKey: "daughter" },
  { radioLabel: "Son", radioKey: "son" },
  { radioLabel: "Other", radioKey: "other" },
];

export const radioFinancialYearData = [
  { radioLabel: "2020-2021", radioKey: "2021" },
  { radioLabel: "2021-2022", radioKey: "2022" },
  { radioLabel: "2022-2023", radioKey: "2023" },
  { radioLabel: "2023-2024", radioKey: "2024" },
  { radioLabel: "2024-2025", radioKey: "2025" },
];

export const NotificationData = [
  {
    preIcon: HandHeartIcon,
    title: "EMI date approaching!",
    description: "Your next EMI for personal loan is due in 5 days.",
    date: new Date("2024-02-06"),
    isNotificationRead: false,
  },
  {
    preIcon: CardAccountDetailsIcon,
    title: "Add Nominee for Mutual Funds",
    description:
      "We noticed you do not have any nominee added for your MutualFunds. Click here to add now.",
    date: new Date("2024-01-06"),
    isNotificationRead: true,
  },
  {
    preIcon: HandHeartOutlineIcon,
    title: "Recommended for you",
    description:
      "Based on your existing journey, we have a pre-approved loan just for you!",
    date: new Date("2024-06-17"),
    isNotificationRead: false,
  },
  {
    preIcon: ElectricityBillIcon,
    title: "Pay your electricity bill, 20 days left!",
    description:
      "Get ₹50 cash back by successfully adding your electricity bill",
    date: new Date("2024-11-21"),
    isNotificationRead: true,
  },
  {
    preIcon: HandHeartIcon,
    title: "Complete your life insurance",
    description:
      "You left your life insurance application midway. Click here to complete it.",
    date: new Date("2024-06-14"),
    isNotificationRead: true,
  },
];
export const LI_PolicyRegex = /^\d{0,9}$/;
export const HI_PolicyRegex = /^\d{2}-\d{2}-\d{7}-\d{2}$/;
export const panRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
export const phoneRegex = /^[6-9]\d{9}$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const dobRegex =
  /^(0[1-9]|[12][0-9]|3[01])\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}$/;
export const termPlanDetails = {
  topSection: [
    { label: "Policy No.", value: "008368298" },
    { label: "Plan Name", value: "ABSLI Life Shield 2017 Lev T40 P40" },
    { label: "Start Date", value: "30-03-2017" },
  ],
  bottomSection: [
    { label: "Sum Assured", value: "₹5 Crores" },
    { label: "Policy Term", value: "40 years" },
    { label: "Payment Term", value: "40 years" },
    { label: "Premium", value: "₹3,081.28" },
    { label: "Mode", value: "Half-Yearly" },
    { label: "Due Date", value: "23 Mar 2023" },
  ],
};

export const radioListRelationshipData = [
  { label: "Mother", key: "Mother" },
  { label: "Father", key: "Father" },
  { label: "Spouse", key: "Spouse" },
  { label: "Daughter", key: "Daughter" },
  { label: "Son", key: "Son" },
  { label: "other", key: "other" },
];

export const appSwitchHeaderList = [
  {
    preIcon: adityaBirlaInsuranceLogo,
    title: "Your ABC holdings",
    subTitle: "Track, Manage, Service & More",
    radioKey: "csApp",
  },
  {
    preIcon: abcdLogoRed,
    title: "Explore Financial Products",
    subTitle: "Pay, Invest, Borrow, Insure & More",
    radioKey: "abcdApp",
  },
];
export const termsAndConditionsTitle = `Terms and Conditions`;
export const privacyPolicyTitle = `Privacy Policy`;
export const aboutUsTitle = `About Us`;
export const monthsList = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const policyStatusListForTaxAndPremiumReceiptPolicyBond = [
  "WAIVER",
  "PAID-UP ANNUITY/EXTENDED TERM",
  "RPU ULIP",
  "PREMIUM PAYING",
  "LAPSED",
  "DISCONTINUED-PAYOUT PENDING",
];
export const policyStatusListForPolicyAccountStatement = [
  "WAIVER",
  "PAID-UP ANNUITY/EXTENDED TERM",
  "SURRENDER PAYOUT PENDING",
  "PREMIUM PAYING",
  "PAID-UP LIFE",
];

export const policyStatusListForUpdatePAN = [
  "PREMIUM WAIVER OR PAYOR DEATH",
  "PAID-UP ANNUITY/ EXTENDED TERM-ULIP",
  "RPU ULIP",
  "PREMIUM PAYING",
  "LAPSED",
  "DISCONTINUED",
  "VESTED ANNUITY",
];

export const policyStatusListForAddUpdateNominees = [
  "PREMIUM PAYING",
  "PAID-UP LIFE",
  "ETI",
  "PAID-UP ENDOWMENT",
  "PAID-UP ANNUITY/EXTENDED TERM-ULIP",
  "PAID-UP ANNUITY/EXTENDED TERM",
  "ANNUITY",
  "TERM",
];

export const documentTypeForTaxCertificate = "Tax Certificate";
export const documentTypeForPremiumReceipt = "Premium Receipt";
export const documentTypeForPolicyAccountStatement = "Policy Account Statement";
export const agentCodeValue = `a2p9i9`;
export const dbDetailValue = `RWS`;

export const EVENT_HANDLER = {
  LOGOUT_EVENT: "Logout",
  EXTEND_SESSION_EVENT: "ExtendSession",
  GO_TO_SUPER_APP_EVENT: "GoToSuperApp",
  DOWNLOAD_DOCUMENT: "DownloadDocument",
};
export const GTAScreenType = {
  LIScreenType: "li_servicing",
  HI_ScreenType: "hi_servicing",
  HFScreenType: "hfl_servicing",
  MFScreenType: "mf_servicing",
  StockScreenType: "ss_servicing",
  DashboardScreenType: "servicing_homescreen_dashboard",
  PreLoginScreenType: "servicing_pre_login",
  LoginScreenType: "servicing_login",
};
export const EVENT_SESSION_TIMEOUT = {
  MSG: "LOG OUT DUE TO SESSION TIMEOUT",
};

export const staticReqPayloadApis = [
  Api_FetchPolicyDetails,
  Api_GetCustomerLobDetails,
  Api_FetchDashboardDetails,
  Api_DownloadTaxCertificate,
  APi_DownloadPolicyAccountStatement,
  Api_FetchProfile_Details,
  Api_SendEmail,
  Api_SendWhatsApp,
  Api_FetchPolicyDetailsByMobileNumber,
];

export const hiQuickMenuList: T_menu[] = [
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 1,
    menuName: "Policy Documents",
    menuDisplayName: "Policy Documents",
    menuIcon: folderIcon,
    parentMenuId: 2,
    menuDetails: [],
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 2,
    menuName: "Renewals",
    menuDisplayName: "Renewals",
    menuIcon: renewalsIcon,
    parentMenuId: 2,
    menuDetails: [],
    functionalityCode: "06PR",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 3,
    menuName: "My Claims",
    menuDisplayName: "My Claims",
    menuIcon: myClaimsIcon,
    parentMenuId: 2,
    menuDetails: [],
  },
  // {
  //   ctaIcon1: KeyboardArrowRightIcon,
  //   menuId: 4,
  //   menuName: "Edit Policy",
  //   menuDisplayName: "Edit Policy",
  //   menuIcon: VectorIcon,
  //   parentMenuId: 2,
  //   menuDetails: [],
  // },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 5,
    menuName: "My Requests",
    menuDisplayName: "My Requests",
    menuIcon: myRequestIcon,
    parentMenuId: 2,
    menuDetails: [],
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 6,
    menuName: "Create ABHA ID",
    menuDisplayName: "Create ABHA ID",
    menuIcon: createABHAIdIcon,
    parentMenuId: 2,
    menuDetails: [],
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 7,
    menuName: "Call a doctor",
    menuDisplayName: "Call a doctor",
    menuIcon: calladoctorIcon,
    parentMenuId: 2,
    menuDetails: [],
    functionalityCode: "06CD",
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 8,
    menuName: "Utilities",
    menuDisplayName: "Utilities",
    menuIcon: utilitiesIcon,
    parentMenuId: 2,
    menuDetails: [],
  },
  // {
  //   title: "Utilities",
  //   preIcon: utilitiesIcon,
  //   postIcon: KeyboardArrowRightIcon,
  // },
];

export const hiPolicyDocumentList: T_menu[] = [
  {
    ctaIcon1: DownloadIcon,
    menuId: 1,
    menuName: "E- Card",
    menuDisplayName: "E- Card",
    menuIcon: IdCardIcon,
    parentMenuId: 1,
    menuDetails: [],
  },
  {
    ctaIcon1: DownloadIcon,
    menuId: 2,
    menuName: "Policy wording",
    menuDisplayName: "Policy wording",
    menuIcon: VectorIcon,
    parentMenuId: 1,
    menuDetails: [],
  },
  {
    ctaIcon1: DownloadIcon,
    menuId: 3,
    menuName: "Premium certificate",
    menuDisplayName: "Premium certificate",
    menuIcon: CertificateIcon,
    parentMenuId: 1,
    menuDetails: [],
  },
  {
    ctaIcon1: DownloadIcon,
    menuId: 3,
    menuName: "Policy schedule",
    menuDisplayName: "Policy schedule",
    menuIcon: CalendarIcon,
    parentMenuId: 1,
    menuDetails: [],
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 3,
    menuName: "Medical reports",
    menuDisplayName: "Medical reports",
    menuIcon: HospitalBoxIcon,
    parentMenuId: 1,
    menuDetails: [],
  },
];

export const hiEditPolicyTabItems = [
  "Proposer Details",
  "Contact details",
  "Nominee details",
];

export const hiEditPolicyProposalFrom = [
  {
    key: "PolicyOwnerName",
    title: "Proposer Name",
    icon: PencilIcon,
    type: "text",
    editLabel: "Name",
  },
  {
    key: "DateOfBirth",
    title: "DOB",
    icon: CalendarIcon,
    type: "dob",
    editLabel: "DOB",
  },
  {
    key: "pan",
    title: "PAN",
    icon: PencilIcon,
    type: "text",
    editLabel: "PAN",
  },
  {
    key: "aadhar",
    title: "Aadhar",
    icon: null,
  },
  {
    key: "Gender1",
    title: "Gender",
    icon: PencilIcon,
    editLabel: "PAN",
  },
];

export const hiEditPolicyContactForm = [
  {
    key: "Mobile",
    title: "Mobile Number",
    icon: PencilIcon,
    type: "text",
  },
  {
    key: "NomineeContactNumber",
    title: "Alternate Mobile Number",
    icon: PencilIcon,
    type: "text",
  },
  {
    key: "Email",
    title: "Email ID",
    icon: PencilIcon,
    type: "text",
  },
  {
    key: "Address",
    title: "Address",
    icon: PencilIcon,
    type: "text",
  },
];

export enum DashboardTabKeys {
  Insurance = "Insurance",
  Investment = "Investment",
  Loans = "Loans",
}

export const DashboardTabValues = [
  {
    tabKey: DashboardTabKeys.Insurance,
    tabValue: ["Life Insurance", "Health Insurance"],
  },
  {
    tabKey: DashboardTabKeys.Investment,
    tabValue: ["Mutual Funds", "Stocks & Securities"],
  },
  {
    tabKey: DashboardTabKeys.Loans,
    tabValue: ["Loans"],
  },
];

export const FolioNumberList = [
  { label: "123475950", value: "123475950" },
  { label: "123475950", value: "123475950" },
  { label: "1016978328", value: "1016978328" },
];

export const FolioNumberAccountList = [
  { label: "123475950", value: "123475950" },
  { label: "123475950", value: "123475950" },
  { label: "123475950", value: "123475950" },
];

export const SchemeListValue = [
  { label: "ABC Scheme One", value: "ABC Scheme One" },
  { label: "ABC scheme Two", value: "ABC Scheme Two" },
];

export const ReportType = [
  { label: "Summary", value: "2" },
  { label: "Transactional", value: "3" },
  {
    label: "Both Summary and Transactional",
    value: "1",
  },
];

export const AdvisorDetails = [
  { label: "No", value: "N" },
  {
    label: "Yes (Broker Details to be displayed)",
    value: "Y",
  },
];

export const documentFormat = [
  { label: "Excel format", key: "excel" },
  { label: "Pdf format", key: "pdf" },
];

export const hiUtilitiesList = [
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 1,
    menuName: "Cashless network hospital",
    menuDisplayName: "Cashless network hospital",
    menuIcon: CashlessNetworkIcon,
    parentMenuId: 2,
    menuDetails: [],
    pathname: "CashlessNetworkHospital",
    functionalityCode: "06NH",
  },

  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 2,
    menuName: "BMI Calculator",
    menuDisplayName: "BMI Calculator",
    menuIcon: bmiCalculatorIcon,
    parentMenuId: 2,
    menuDetails: [],
    pathname: "bmiCalculator",
    functionalityCode: "06BMI",
  },
  {
    ctaIcon1: ArrowOutwardIcon,
    menuId: 3,
    menuName: "Active age calculator",
    menuDisplayName: "Active age calculator",
    menuIcon: activeAgeCalculatorIcon,
    parentMenuId: 2,
    menuDetails: [],
    pathname: "activeAgeCalculator",
  },
];

export const HLQuickList = [
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 1,
    menuName: "Statement & documents",
    menuDisplayName: "Statement & documents",
    menuIcon: folderIcon,
    parentMenuId: 12,
    menuDetails: [],
    isNavIcon: true,
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 2,
    menuName: "Service requests",
    menuDisplayName: "Service requests",
    menuIcon: serviceRequestIcon,
    parentMenuId: 12,
    menuDetails: [],
    isNavIcon: true,
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 3,
    menuName: "Disbursement request",
    menuDisplayName: "Disbursement request",
    menuIcon: handCoinIcon,
    parentMenuId: 12,
    menuDetails: [],
    isNavIcon: true,
  },
];

export const HLStatementsAndDocuments: T_menu[] = [
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 1,
    menuName: "Statement of Account",
    menuDisplayName: "Statement of Account",
    menuIcon: textBoxIcon,
    parentMenuId: 12,
    menuDetails: [],
    isNavIcon: true,
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 2,
    menuName: "Interest Certification",
    menuDisplayName: "Interest Certification",
    menuIcon: CertificateIcon,
    parentMenuId: 12,
    menuDetails: [],
    isNavIcon: true,
  },
  {
    ctaIcon1: emailIcon,
    ctaIcon2: downloadHL,
    menuId: 3,
    menuName: "Welcome Kit",
    menuDisplayName: "Welcome Kit",
    menuIcon: welcomeKitIcon,
    parentMenuId: 12,
    menuDetails: [],
    isNavIcon: false,
  },
  {
    ctaIcon1: emailIcon,
    ctaIcon2: downloadHL,
    menuId: 4,
    menuName: "Repayment Schedule",
    menuDisplayName: "Repayment Schedule",
    menuIcon: CalendarIcon,
    parentMenuId: 12,
    menuDetails: [],
    isNavIcon: false,
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 5,
    menuName: "Balance Confirmation Letter",
    menuDisplayName: "Balance confirmation letter",
    menuIcon: textBoxCheckIcon,
    parentMenuId: 12,
    menuDetails: [],
    isNavIcon: true,
  },
  {
    ctaIcon1: emailIcon,
    menuId: 6,
    menuName: "GST Invoice",
    menuDisplayName: "GST invoice",
    menuIcon: textBoxIcon,
    parentMenuId: 12,
    menuDetails: [],
    isNavIcon: false,
  },
  {
    ctaIcon1: emailIcon,
    menuId: 7,
    menuName: "List of documents",
    menuDisplayName: "List of documents",
    menuIcon: playListIcon,
    parentMenuId: 12,
    menuDetails: [],
    isNavIcon: false,
  },
  {
    ctaIcon1: emailIcon,
    menuId: 8,
    menuName: "Insurance copy",
    menuDisplayName: "Insurance copy",
    menuIcon: folderIconNew,
    parentMenuId: 12,
    menuDetails: [],
    isNavIcon: false,
  },
  // {
  //   ctaIcon1: redirectionIcon,
  //   menuId: 9,
  //   menuName: "More documents",
  //   menuDisplayName: "More documents",
  //   menuIcon: folderIconNew,
  //   parentMenuId: 12,
  //   menuDetails: [],
  //   isNavIcon: true,
  // },
];

export const FeedbackOptions = [
  {
    label: "Worst",
    key: "worst",
    preIcon: worstIcon,
    postIcon: worstClickIcon,
  },
  { label: "Bad", key: "bad", preIcon: badIcon, postIcon: badClickIcon },
  { label: "Fine", key: "fine", preIcon: fineIcon, postIcon: fineClickIcon },
  { label: "Good", key: "good", preIcon: goodIcon, postIcon: goodClickIcon },
  { label: "Best", key: "best", preIcon: bestIcon, postIcon: bestClickIcon },
];

export const HL_IdentifierConstant = [
  "HL",
  "HL_INFRML",
  "HL_PLUS",
  "HL_PMR",
  "HL_PRIME",
  "HLPNL",
];
export const HLServiceRequest: T_menu[] = [
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 132,
    menuName: "Change email",
    menuDisplayName: "Change email",
    menuIcon: emailIcon,
    parentMenuId: 18,
    menuDetails: [],
    //isNavIcon: true,
  },
  // {
  //   ctaIcon1: KeyboardArrowRightIcon,
  //   menuId: 133,
  //   menuName: "Change mobile",
  //   menuDisplayName: "Change mobile",
  //   menuIcon: changeMobileIcon,
  //   parentMenuId: 18,
  //   menuDetails: [],
  //   //isNavIcon: true,
  // },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 91,
    menuName: "Change address",
    menuDisplayName: "Change address",
    menuIcon: changeAddressIcon,
    parentMenuId: 18,
    menuDetails: [],
    isNavIcon: true,
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 92,
    menuName: "Change EMI date",
    menuDisplayName: "Change EMI date",
    menuIcon: changeEmiIcon,
    parentMenuId: 18,
    menuDetails: [],
    isNavIcon: true,
  },
  // {
  //   ctaIcon1: KeyboardArrowRightIcon,
  //   menuId: 131,
  //   menuName: "Change EMI/Tenure",
  //   menuDisplayName: "Change EMI/Tenure",
  //   menuIcon: changeEmiTenureIcon,
  //   parentMenuId: 18,
  //   menuDetails: [],
  //   isNavIcon: true,
  // },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 93,
    menuName: "Excess EMI refund",
    menuDisplayName: "Excess EMI refund",
    menuIcon: excessEmiRefundIcon,
    parentMenuId: 18,
    menuDetails: [],
    isNavIcon: true,
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 130,
    menuName: "TDS refund",
    menuDisplayName: "TDS refund",
    menuIcon: tdsRefundIcon,
    parentMenuId: 18,
    menuDetails: [],
    isNavIcon: true,
  },
  {
    ctaIcon1: KeyboardArrowRightIcon,
    menuId: 94,
    menuName: "Register/Change E-Nach",
    menuDisplayName: "Register/Change E-Nach",
    menuIcon: changeEnachIcon,
    parentMenuId: 18,
    menuDetails: [],
    isNavIcon: true,
  },
  {
    ctaIcon1: redirectionIcon,
    menuId: 152,
    menuName: "More services",
    menuDisplayName: "More services",
    menuIcon: viewDashboard,
    parentMenuId: 18,
    menuDetails: [],
    isNavIcon: true,
  },
];

export const HiNomineeRelationship = [
  {
    value: "Mother",
    label: "Mother",
  },
  {
    value: "Father",
    label: "Father",
  },
  {
    value: "Spouse",
    label: "Spouse",
  },
  {
    value: "Daughter",
    label: "Daughter",
  },
  {
    value: "Son",
    label: "Son",
  },
  {
    value: "Mother-in-law",
    label: "Mother-in-law",
  },
  {
    value: "Father-in-law",
    label: "Father-in-law",
  },
];

export const StatementType = [
  {
    value: "FinancialYear",
    label: "Select a financial Year",
  },
  {
    value: "DateRange",
    label: "Select date range",
  },
];

export const downloadPopOptions = [
  {
    title: "Download",
    icon: DownloadIcon,
  },
  {
    title: "Email",
    icon: emailIcon,
  },
];

export const HiEditPolicyNomineeForm = [
  {
    key: "Nominee details",
    title: "Nominee Details",
    icon: PencilIcon,
    type: "text",
  },
];
export const FinancialYearMonth = 4;

export const hlTermsandConditions = [
  'Aditya Birla Home Finance Limited ("ABHFL") offers you the option of paying the Overdue amounts on your loan availed from ABHFL, by using the online payment facilities. The payment processed is through "Bill Desk" (Third Party). Please read these conditions of the Disclaimer carefully. By using the online payment facility, you agree to be bound by these terms contained herein.',
  "For making online payment, you will access a third party site. ABHFL does not in any way warrant the accuracy or completeness of the information, materials, services or the reliability of any service, advice, opinion, statement or other information displayed or distributed through such third party site. Customer may access this site solely for purposes of repayment of your Loan and you understand and acknowledge that availing of any services offered on the site or your reliance on any opinion, advice, statement, memorandum, or information available on the site shall be at your sole risk and discretion.",
  " Aditya Birla Home Finance Ltd. and its affiliates, subsidiaries, employees, officers, directors and agents, expressly disclaim any liability for any deficiency in the services of the Payment Gateway Provider. Neither Aditya Birla Home Finance Ltd. nor any of its affiliates nor their directors, officers and employees will be liable to or have any responsibility of any kind for any loss that you incur arising out of any deficiency in the services of the Payment Gateway Provider to whom the site belongs, failure or disruption of the site of Payment Gateway Provider, or resulting from the act or omission of any other party involved in making this site or the data contained therein available to you, or from any other cause relating to your access to, inability to access, or use of the site or these materials.",
  "ABHFL may change the terms of this disclaimer, at any time and without notice. It is recommended that you review the terms of this disclaimer, periodically for changes. ABHFL shall not be held responsible for all or any actions that may subsequently result in any loss, damage and or liability on account of such change in the information on this website.",
  "I hereby confirm that I am the borrower and declare that the overdue amount paid is being paid from the income earned from legitimate funds and from a bank account/credit card which belongs to me. I understand and agree that this is a regulatory requirement.",
  "I hereby confirm that I have read and agree to abide by the conditions of the Disclaimer for using the online payment facility.",
];

export const PaymentStatusList = ["SUCCESS", "FAILURE", "PENDING"];

const LiBaseCaseCreateReqBody = {
  ONBEHALFOF: "Customer",
  ADVISORCODE: "",
  CUSTOMERID: "",
  POLICYNO: "",
  EMAILID: "",
  FIRSTNAME: "",
  LASTNAME: "",
  MOBILENO: "",
  SMSSHORTCODE: "",
  REMARKS: "",
  CATEGORY: "",
  FLSCASE: "",
  CASETYPE: "",
  CASESUBTYPE: "",
  CASESUBSUBTYPE: "",
  SOURCE: "ABC_Servicing_App",
  FTR: "",
  UDP1: "",
  UDP2: "",
  UDP3: "",
  UDP4: "",
  UDP5: "",
  ClientIPAddress: "",
  VoucherNo: "",
  VoucherDate: "",
  DocumentUrl: "",
  lstNomineeUpdate: [],
  POIOption1: "",
  POIOption2: "",
  POIOption3: "",
  Aadhar_number: "",
  Aadhar_Valid_Status: "",
  PAN_number: "",
  Pan_Valid_status: "",
  Address1: "",
  Address2: "",
  Address3: "",
  Area: "",
  City: "",
  Pincode: "",
  State: "",
  Country: "",
  Address_Valid_status: "",
  Address_STP_Flag: "",
  Account_number: "",
  Account_type: "",
  IPFSC_code: "",
  MICRCode: "",
  Bank_name: "",
  Branch_name: "",
  Bank_valid_status: "",
  TransactionId: "",
};

export const LiUpdatePanCaseCreateSampleReqBody: T_CreateCaseRequest = {
  ...LiBaseCaseCreateReqBody,
  CODE: "PNFT009",
  NsdlAPIStatus: "SUCCESS",
  NameAsNsdl: "",
  PolicyOwnerName: "",
  NameMatchPercent: "",
  NameMatchAPIStatus: "",
  NameMatched: "",
  FunctionalityCode: InAppFeatureFuncCodes.LI_UPDATE_PAN,
};

export const LiUpdateEmailCreateSampleReqBody: T_CreateCaseRequest = {
  ...LiBaseCaseCreateReqBody,
  CODE: "PNFT007",
  Bank_IMPS_Status_Code: "",
  HOLD_CIT_OF_O_Country: "",
  Tax_Resi_of_other_country: "",
  country_name: "",
  Tax_iden_number: "",
  ReinstatementAmount: "",
  Medicals: "",
  COI_COVID_Quest: "",
  PXResponse: "",
  COISignedDate: "",
  AnniversaryDate: "",
  MethodChange: "",
  OldFrequency: "",
  NewFrequency: "",
  DynamicLinkGUID: "",
  FunctionalityCode: InAppFeatureFuncCodes.LI_UPDATE_EMAIL,
};

const HlBaseCaseCreateReqBody = {
  customerId: "",
  accountNumber: "",
  firstName: "",
  lastName: "",
  mobile: "",
  emailId: "",
  subject: "",
  source: "ABC_Servicing_App",
  subtype: "",
  comments: "",
  isClosed: true,
  url: "",
  category: "Request",
  lob: "HFC",
  priority: "Low",
  segment: "Finance",
  callbackDate: "",
  callbackTimeSlot: "",
  stpsRequestType: "",
  asOnDate: "",
  salaryCreditDate: "",
  dueDate: "",
  changeInEmiAmount: "",
  payableCharge: "",
  payPaymentAmount: "",
  partPaymentAmount: "",
  impact: "",
  modeOfRepayment: "",
  soaFromDate: "",
  soaToDate: "",
  icFromYear: "",
  icToYear: "",
  attachments: null,
  FunctionalityCode: "",
};

export const HlChangeEmailCaseCreateSampleReqBody = {
  ...HlBaseCaseCreateReqBody,
  NEWEMAILID: "",
  NEWMOBILENUMBER: "",
  MODEOFCHANGEOFADDRESS: "",
  subject: "Email Update",
  subtype: "hfl023",
  FunctionalityCode: InAppFeatureFuncCodes.HL_UPDATE_EMAIL,
};

export const HlBalanceConfirmCaseCreateSampleReqBody = {
  ...HlBaseCaseCreateReqBody,
  subject: "Statements & Documents-BalanceConfirmationLetter",
  subtype: "hfl005",
  FunctionalityCode:
    InAppFeatureFuncCodes.HL_STATEMENTS_DOCUMENTS_BALANCE_CONFIRMATION_LETTER,
};

export const HlChangeMobileCaseCreateSampleReqBody = {
  ...HlBaseCaseCreateReqBody,
  NEWEMAILID: "",
  NEWMOBILENUMBER: "",
  MODEOFCHANGEOFADDRESS: "",
  subject: "Mobile number Change",
  subtype: "hfl045",
  FunctionalityCode: InAppFeatureFuncCodes.HL_MOBILE_NUMBER_CHANGE,
};

export const SET_ALERT_MESSAGE =
  "Alert will be sent to your registered Email ID";

export const LiUpdateMobileNumberCreateSampleReqBody: T_CreateCaseRequest = {
  ...LiBaseCaseCreateReqBody,
  CODE: "PNFT008",
  FunctionalityCode: InAppFeatureFuncCodes.LI_UPDATE_MOBILE_NUMBER,
};

export const FAQDisclaimerTitle = "Disclaimer";

export const FAQDisclaimerContent =
  "The answers provided here are for informative purposes and may be subject to change, and ABHFL does not warrant their accuracy, adequacy, appropriacy, completeness or reliability. The User understands that nothing contained here is professional legal, commercial or investment advice, and shall not be binding on ABHFL. The User is advised to make investment decisions after conducting their own diligence and research.";
export const rateUsCmsContentData = <T_CmsRateContentVariables>{
  attributes: {
    title: "FINDING A FRIEND IN OUR APP?",
    subTitle: "Tell us how you're feeling in our company?",
    checkBox:
      "ABCD App team or it's research partners can reach me for suggestions on improving ABCD App experience",
    lowRatingDescription: "OH-OH! TELL US WHAT WENT WRONG",
    highRatingDescription: "Tell us about your experience",
    successTitle: "GOTCHA!",
    successMessage:
      "Thank you for sharing your input. We'll come back better than ever before",
  },
  id: 1,
};

export const LI_Appointee_TAC = [
  "1. As per Insurance Act, 1938, as amended from time to time, the nomination cannot be effected if the Policyholder and the Life Insured are two different persons.",
  "2. All previous nominations shall be automatically cancelled on submission of this form and the nomination last received by the Company shall prevail over all previous nominations.",
  "3. If the nomination is in favour of a minor, an appointee who is a major must be named in this form.",
  "4. The Company expresses no opinion as to the validity of the nomination.",
  "5. Any change in the nomination that is made without the knowledge/consent of the Policyholder shall not be valid.",
];

export const LI_Appointee_Declaration = {
  title: "Declaration: ",
  content:
    "I have understood the meaning and scope of this change request form and take complete responsibility for the change submitted by me herein. I understand that any change in Nominee details is subject to the Policy terms, conditions and relevant underwriting guidelines. I understand that this is only a change request form and that the Company shall not be under any obligation to make the changes proposed herein. I confirm that I have read and understood all the relevant policy provisions and their consequences before making submitting this change request.",
};
export const policyRenewalEncryptionIV = "5891233561234567";
export const policyRenewalEncryptionSecretKey = "5891233561234567";
export const policyRenewalSource = "ABC App";

export const HlExcessEMIRefundCaseCreateSampleReqBody: T_CreateCaseAPIRequest =
  {
    ...HlBaseCaseCreateReqBody,
    customerId: "240893",
    accountNumber: "LNZKPLAP-08190055420",
    firstName: "SUNIL",
    lastName: "SHARMA",
    mobile: "2408930000",
    emailId: "240893@email.com",
    subject: "Account Related-EMIExcessRelated",
    subtype: "RWRORHFC",
    isClosed: false,
    priority: "LOW",
    attachments: [],
    document: [],
    FunctionalityCode: "",
  };

export const LiAddUpdateBackAccountDetailCaseCreateSampleReqBody: T_CreateCaseRequest =
  {
    ...LiBaseCaseCreateReqBody,
    CODE: "PNFT034",
    REMARKS: "NON_PENNY",
    Account_number: "40796329588",
    Account_type: "803170000",
    IPFSC_code: "SBIN0002486",
    MICRCode: "000000000",
    Bank_name: "STATE BANK OF INDIA",
    Branch_name: "SIWANI",
    Bank_valid_status: "Y",
    PolicyOwnerName: "",
    DynamicLinkGUID: "424296ef-233d-ef11-812f-00155dc977d0",
    Bank_Account_Holder_Name: "Mrs. Anju  Devi",
    Bank_IMPS_Verification_Flag: "Y",
    Bank_IMPS_Date: "2024-07-08",
    Bank_IMPS_Status_Code: "0",
    Bank_IMPS_Reason: "Transaction Successfull",
    BANK_STP_Flag: "Y",
    MatchPercentage: "1",
    TransactionId: "395045987017164630201509",
    FunctionalityCode: InAppFeatureFuncCodes.LI_ADD_UPDATE_BANK_ACCOUNT,
  };

export const karzaApiNSTPStatusCode: string[] = [
  "KC02",
  "KC04",
  "KC08",
  "KC09",
  "KC10",
  "KC11",
  "KC13",
  "KC14",
  "KC15",
  "KC17",
  "KC18",
  "KC20",
  "KC22",
  "KC23",
  "KC24",
  "KC26",
  "KC30",
  "KC31",
  "KC32",
  "KC33",
  "KC35",
  "KC36",
  "KC37",
  "KC38",
  "KC39",
  "KC41",
  "KC42",
  "KC43",
  "KC44",
  "KC48",
  "KC56",
];
export const karzaApiSTPStausCode = [
  { stauscode: "KC01", message: "Success message as per current process" },
  {
    stauscode: "KC03",
    message:
      "Invalid Beneficiary Account Number or IFSC. Kindly enter correct details.",
  },
  {
    stauscode: "KC05",
    message:
      "Your Account is Blocked/Frozen. Please retry with Valid/Active bank account details.",
  },
  {
    stauscode: "KC06",
    message:
      "Beneficiary Bank account is not eligible. Kindly provide alternate bank account details.",
  },
  {
    stauscode: "KC07",
    message:
      "Your Account is Closed. Kindly retry with Active bank account details.",
  },
  {
    stauscode: "KC12",
    message:
      "Beneficiary Bank account is not eligible. Kindly provide alternate bank account details.",
  },
  {
    stauscode: "KC16",
    message:
      "Beneficiary Bank account is not eligible. Kindly provide alternate bank account details.",
  },
  {
    stauscode: "KC19",
    message:
      "Invalid Beneficiary Account Number or IFSC. Kindly enter correct details.",
  },
  {
    stauscode: "KC21",
    message:
      "Account is invalid for transaction. Kindly retry with valid bank account details..",
  },
  {
    stauscode: "KC25",
    message:
      "Beneficiary Bank account is not eligible. Kindly provide alternate bank account details.",
  },
  {
    stauscode: "KC27",
    message:
      "Account is invalid for transaction. Kindly retry with valid bank account details.",
  },
  {
    stauscode: "KC34",
    message:
      "Account is invalid for transaction. Kindly retry with valid bank account details.",
  },
  {
    stauscode: "KC40",
    message:
      "Invalid Beneficiary IFSC Code or NBIN. Kindly enter correct details.",
  },
  {
    stauscode: "KC45",
    message:
      "Account is invalid for transaction. Kindly retry with valid bank account details.",
  },
  {
    stauscode: "KC46",
    message:
      "Account is invalid for transaction. Kindly retry with valid bank account details.",
  },
  {
    stauscode: "KC47",
    message:
      "Account is invalid for transaction. Kindly retry with valid bank account details.",
  },
];
export const liRedirectionFunctionalityCodes = [
  "P",
  "D",
  "MC",
  "ENACH",
  "LR",
  "LA",
  "FS",
  "ESI",
  "CI",
  "SC",
  "D",
  "CT",
  "ST",
  "EI",
];

export const pageMessages = {
  "update-pan": "PM02",
  "update-mobile": "PM03",
  "update-email-request": "PM05",
  "update-email-success": "PM04",
  "update-email-register": "PM06",
  "update-whatsapp-optout": "PM07",
  "update-whatsapp-optin": "PM08",
  "add-update-bank-account": "PM09",
  "add-update-nominee": "PM10",
  "update-tdsrefund-success": "PM12",
  "excess-emi-refund": "PM11",
  "li-statement-download-flow": "PM12",
  "li-statement-whatsapp-flow": "PM13",
  "li-statement-email-flow": "PM14",
  "li-policy-bond": "PM15",
};
export const otpExpirationCoolOffPeriod: string = "30 minutes";
export const HomeLoanStatmentConstant = "04";
export const HomeLoanStatmentActiveValue = "active";

export const radioListTdsData = [
  { radioLabel: "Digitally Signed TDS Certificate", radioKey: "digitally" },
  { radioLabel: "Manually Signed TDS Certificate", radioKey: "manually" },
];

export const Branch_Locator_Url =
  "https://homefinance.adityabirlacapital.com/pages/branches.aspx";

export enum HlSuccessMessages {
  VISIT_BRANCH = "HL01",
  CHANGE_ADDRESS = "HL02",
  EXCESS_EMI_REFUND = "HL03",
  TDS_REFUND = "HL04",
  CHANGE_EMI_TENURE = "HL05",
  CHANGE_EMI_DATE = "HL06",
  CHANGE_MOBILE_NUMBER = "HL07",
  CHANGE_EMAIL_ID = "HL08",
  INSURANCE_COPY_EMAIL = "HL09",
  DOCUMENTS_EMAIL = "HL10",
  GST_INVOICE_EMAIL = "HL11",
  BALANCE_CONFIRMATION_DOWNLOAD = "HL12",
  BALANCE_CONFIRMATION_EMAIL = "HL13",
  INSURANCE_COPY_DOWNLOAD = "HL14",
  DOCUMENTS_DOWNLOAD = "HL15",
  GST_INVOICE_DOWNLOAD = "HL16",
  WELCOME_KIT_EMAIL = "HL17",
  WELCOME_KIT_DOWNLOAD = "HL18",
  REPAYMENT_SCHEDULE_EMAIL = "HL19",
  REPAYMENT_SCHEDULE_DOWNLOAD = "HL20",
}

export enum ErrorMessageCodes {
  // Only alphanumeric characters and , . / - ( ) & are permitted
  HI_ALLOWED_CHAR = "CS_HI_VAL_MS_200",

  // Re send OTP allowed to use for three times only for the session
  GA_3OTP = "CS_GA_3OTP_MS_200",

  // Please retry after 30 mins
  GA_ROTP = "CS_GA_ROTP_MS_200",

  // Incorrect OTP, please try again later
  GA_IOTP = "CS_GA_IOTP_MS_200",

  // Please enter valid PAN
  GA_VPAN = "CS_GA_VPAN_MS_200",

  // Please enter a valid mobile number
  GA_VMNO = "CS_GA_VMNO_MS_200",

  // Re send OTP allowed to use for three times only for the session
  LI_ROTP = "CS_LI_ROTP_MS_200",

  // Entry of three OTP wrong shall be allowed
  LI_3OTP = "CS_LI_3OTP_MS_200",

  // Incorrect OTP, please try again
  LI_IOTP = "CS_LI_IOTP_MS_200",

  // Please enter a valid Email ID
  LI_VEID = "CS_LI_VEID_MS_200",

  // Request submitted recently. You can submit new request after 30 min
  LI_RRU = "CS_LI_RRU_MS_200",
}
export const otpScreenErrorMsg =
  "You have reached the maximum attempt of tries. Please try again after 30 minutes.";
export const branchLocatorUrlHomeLoan: string =
  "https://homefinance.adityabirlacapital.com/pages/branches.aspx";
export const changeEmiDateDelinquencyStatusList: string[] = [
  "sma-1",
  "sma-0",
  "doubtfull2",
  "substandar",
  "doubtfull1",
  "doubtfull3",
  "sma-2",
  "sma 0",
];
export const serviceRequestsStatusForActiveTab: string[] = [
  "new",
  "in progress",
  "waiting for customer",
];
export const serviceRequestsStatusForResolvedTab: string[] = [
  "resolved",
  "closed duplicate",
  "unresolved",
];

export const functionalityCodeForGenerateOtpApi: string = "LGN_OTP";

export const hiPolicyStatusInApiResponse: string = "IF";
export const hiPolicyStatus: string = "EXPIRED";

//onBoarding screen constants
export const onBoardingContent =
  "We need your details once for verification. This will not be asked for future login.";
export const statusCode = 404;

export let onUserLoginCleverTapStatic: T_OnUserLoginCleverTapStatic = {
  Name: "",
  Identity: "",
  Email: "",
  Phone: "",
  Gender: undefined,
  DOB: "",
  "MSG-email": false,
  "MSG-push": false,
  "MSG-sms": false,
  "MSG-whatsapp": false,
  Stuff: "",
};

export const pocketInsuranceCmsType = "Pocket-Insurance";
export const travelInsuranceCmsType = "Travel-Insurance";
export const pocketProductCategory = "Pocket Insurance";
export const travelProductCategory = "Travel Insurance";
export const taxCenterCmsType = "Tax-Center";
export const getInsuranceFunctionalityCode: any = {
  "Pocket-Insurance": "PI",
  "Travel-Insurance": "TI",
};

export const serviceMob = "ServiceMob";
export const serviceWeb = "ServiceWeb";
export const serviceApp = "ServiceApp";
export const ABCDService = "ABCDService";

export const platformWeb = "web";
export const platformMobile = "mobile";
export const platformSuperApp = "super app";

//ABCD Holdings Constant
export const digiGoldTitle = "Digital gold";
export const digiGoldLiveText = "Gold";
export const digiSilverTitle = "Digital silver";
export const digiSilverLiveText = "Silver";
export const fixedDepositsTitle = "Fixed deposits";
export const pocketInsuranceTitle = "Pocket Insurance";
export const travelInsuranceTitle = "Travel Insurance";
export const motorInsuranceTitle = "Motor insurance";
export const buyMoreWithABCDText = "Buy more with ABCD";
export const viewMoreDetailsOnAbcd = "View more details on ABCD";
export const recentTransactionsText = "Recent transactions";
export const viewAllText = "View All";
export const claimProcessText = "Claim Process";
export const productCodes = {
  digiGold: "DG",
  digiSilver: "DS",
  fixedDeposit: "deposit",
  pocketInsurance: "PI",
  travelInsurance: "TI",
  motorInsurance: "MI",
};
export const transactionTypes = {
  sell: "SELL",
  redeem: "REDEEM",
  buy: "BUY",
  transfer: "TRANSFER",
};

export const transactionStatus = {
  confirmed: "Confirmed",
  success: "Success",
  failed: "Failed",
  inProgress: "In Progress",
  reversed: "Reversed",
  transferred: "Transferred",
};
export const transactionApiStatus = {
  successful: "successful",
  failed: "failed",
  failure: "failure",
  inProgress: "in progress",
  reversed: "reversed",
  transferred: "transferred",
};
export const recentTransactionsMaxLength = 5;
export const abcdFunctionalityCodes = {
  digiGold: "DG",
  digiSilver: "DS",
  fixedDeposit: "FD",
  pocketInsurance: "PI",
  travelInsurance: "TI",
  motorInsurance: "MI",
};
export const motorInsuranceProductTypes = {
  car: "car",
  bike: "bike",
};

export const motorInsurerNames = {
  iciciLombard: "icici lombard",
  acko: "acko",
  digit: "digit",
};
//export const mobileNumberForUserProductStatusApi = "9080529856";
export const motorInsuranceCertificateName = "Motor_Insurance_Certifcate";
export const errorPopupBodyTitle = "Document is unavailable";
export const errorPopupBodyBtnLabel = "Connect to customer support";
export const travelInsuranceCertificateName = "Travel_Insurance_Certifcate";
export const pocketInsuranceCertificateName = "Pocket_Insurance_Certifcate";
export const motorInsurancePolicyTypeViewPoint = 430;
//ABCD Holdings Constant end here

//Callus popup constants
export const callUsTitle = "CALL US";
export const callUsSubTitle =
  "For help and support, please reach us at this number:";
export const callUsContact = "18002707000";
export const callUsTimings = "Mon–Sun, 9:00 AM – 9:00 PM";

export const supportedPolicyTypes = [
  "PREMIUM WAIVER",
  "PAYOR DEATH",
  "PAID-UP ANNUITY",
  "EXTENDED TERM-ULIP",
  "RPU ULIP",
  "PREMIUM PAYING",
  "LAPSED",
  "DISCONTINUED",
  "TERMINATED",
  "SURRENDERED",
  "WAIVER",
];

export const unifiedBannerType = "Unified Banner";
export const promotionalCardType = "Promotional Banner";
export const nudgeType = "Nudge";
export const buyNewProductType = "Buy New Product";
export const purchaseCTAType = "Explore ABCD";
export const downloadDocumentCode = "DD";

//Purchase CTA constants start here
export const staticPurchaseCtaName = "Explore";
export const staticPurchaseCtaRedirectionUrl =
  "https://adityabirlacapitaldigital.onelink.me/vYLv/a2efnsv7";
export const purchaseCtaMenuName = "Purchase CTA";
export const staticPurchaseCtaFunctionalityCode = "D";
//Purchase CTA constants end here

//OSP-1592 related constant start here
export const staticTitleText = "FEEDBACK PLEASE";
export const subTitleMainText =
  "Please rate your experience based on your recent interaction, with ";
export const subTitleSpanText = "10 being the highest and 0 being the lowest.";
export const staticTextBoxValue =
  "Please share any additional details that could help us improve.";
//OSP-1592 related constant end here

//HFL Change Address Constant
export const changeAddressYesMode = "VKYC";
export const changeAddressNoMode = "FI";
export const changeAddressLob = "HFC";
export const createCaseIsCloseIsTrue = "true";
export const createCaseIsCloseIsFalse = "false";
export const changeAddressYesSubTypeValue = "hfl003";
export const changeAddressNoSubTypeValue: string = "AC123456";
export const changeAddressYesCategory = "Request";
export const changeAddressNoCategory = "Query";

//OSP-1402 related constant end here
export const homePageRouteL1 = "/home";
export const DetailPageRouteL2 = "/details";
export const DetailPageStockRouteL2 = "/my-portfolio";
export const DetailPageMutualFundRouteL2 = "/mutual-fund";

//OSP-2212 constants start here
export const myStatementsText = "My Statements";
export const capitalGainSubMenuName = "Capital Gain Statement";
export const capitalGainFunctionalityKey = "CAPITAL_GAIN_STATEMENT";
export const capitalGainModeText = "CGS";
export const capitalGainModuleName = "Mutual Fund Capital Gain Statement";
export const exitLoadSubMenuName = "Exit Load";
export const exitLoadFunctionalityKey = "EXIT_LOAD_STATEMENT";
export const exitLoadModeText = "ELS";
export const exitLoadModuleName = "Mutual Fund Exit Load Statement";
export const accountStatementSubMenuName = "Account Statement";
export const accountStatementFunctionalityKey = "ACCOUNT_STATEMENT";
export const accountStatementModeText = "AS";
export const accountStatementModuleName = "Mutual Fund Account Statement";
//OSP-2212 constants end here

export const ActiveStatusText = "ACTIVE";

//OSP-1232 related constants start here
export const sfdcSourceName = "ABC_Servicing_App";
export const sfdcIntimationType = "Endorsement";
export const sfdcPriority = "Medium";
export const sfdcChannel = "Digital";
export const sfdcBusinessUnit = "ABHI";
export const sfdcEndorsmentMasterKeys = {
  updateEmailId: "update email id",
  updatePrimaryNumber: "update primary number",
  updateAddress: "communication address change",
  updateNomineeDetails: "nominee modification",
  updateDOB: "dob correction",
  updateGender: "gender correction",
  updateName: "name correction",
  updatePAN: "pan update",
  updateAlternateNumber: "update alternate number",
};
//OSP-1232 related constants end here

export const nameRegex =
  /^[A-Za-z][A-Za-z'’.-]*(?: [A-Za-z'’.-]+)*(?: [A-Za-z'’.-]+)?$/;
export const validNameCharacterRegex = /^[A-Za-z\-\.'’ ]/;
export const validEmailCharacterRegex = /^[a-zA-Z0-9._@-]+$/;
export const pathToLobCodeMap = {
  "/details/li": "02",
  "/details/hi": "06",
  "/mutual-fund": "01",
  "/my-portfolio": "24",
  "/details/hl": "04",
} as const;
export const LobCodeToLobIdMap = {
  "ABSLI": "02",
  "ABHI": "06",
  "ABSLAMC": "01",
  "ABML": "24",
  "ABHFL": "04",
} as const;
export const pathToModuleName = {
  "/details/li": "Life Insurance",
  "/details/hi": "Helath Insurance",
  "/mutual-fund": "Mutual Fund",
  "/my-portfolio": "Stocks",
  "/details/hl": "Home Loan",
  "/home": "Dashboard",
} as const;

export type ModuleNameKey = keyof typeof pathToModuleName;
export type PathKey = keyof typeof pathToLobCodeMap;
export type TaxCenterPathKey = keyof typeof LobCodeToLobIdMap;

export const enableServiceAppDowntimeFlag: boolean = false; //make as true when we need to show downtime at initial level
